import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserTemp } from '../../models/users/user';
import { environment } from 'projects/shared-library/src/environments/environment';

export interface UserPostData {
  // Add properties for creating a new User
}

@Injectable({ providedIn: 'root' })
export class UsersService {
  private baseUrl = '/users';
  private userUrl = `${environment.backendServer}${this.baseUrl}`;
  private dashboardUrl = `${environment.backendServer}/dashboard${this.baseUrl}`;

  constructor(private http: HttpClient) { }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(this.userUrl);
  }

  getDashboardUsers({ options }: { options?: HttpParams } = {}): Observable<User[]> {
    return this.http.get<User[]>(this.dashboardUrl, { params: options });
  }

  createUser(data: UserPostData): Observable<User> {
    return this.http.post<User>(this.userUrl, data);
  }

  getUserById(id: string): Observable<User> {
    return this.http.get<User>(`${this.userUrl}/${id}`);
  }

  getDashboardUserById(id: string): Observable<UserTemp> {
    return this.http.get<UserTemp>(`${this.dashboardUrl}/${id}`);
  }

  updateUser(id: string, data: UserPostData): Observable<User> {
    return this.http.put<User>(`${this.userUrl}/${id}`, data);
  }

  deleteUser(id: string): Observable<User> {
    return this.http.delete<User>(`${this.userUrl}/${id}`);
  }

  approveUser(id: string): Observable<UserTemp> {
    return this.http.put<UserTemp>(`${this.userUrl}/${id}/approve`, {});
  }

  rejectUser(id: string): Observable<UserTemp> {
    return this.http.put<UserTemp>(`${this.userUrl}/${id}/reject`, {});
  }

  getAuthUser(): Observable<UserTemp> {
    return this.http.get<UserTemp>(`${this.userUrl}/auth`);
  }
}
